export default __webpack_public_path__ + "static/media/1-7@2x.a58ddfdd.png";